import React from 'react';
import { useStyletron } from 'baseui';
import { Select, SIZE } from 'baseui/select';
import { TEMPORAL_SCOPE } from '../../../../../modernization-common/relationships/constants';
import type { TemporalScopeT } from '../../../../../modernization-common/relationships/types/relationship';
import { FRAME_CLASSIFICATION_PANEL_CONSTANTS } from './constants';
const OPTIONS = [{
  id: TEMPORAL_SCOPE.INTERVAL,
  label: 'Interval'
}, {
  id: TEMPORAL_SCOPE.INSTANT,
  label: 'Instant'
}];
type PropsT = {
  value: TemporalScopeT;
  onChange: (temporalScope: TemporalScopeT) => void;
  disabled?: boolean;
};
export const InstanceScopeSelect = ({
  value,
  onChange,
  disabled
}: PropsT) => {
  const [css, theme] = useStyletron();
  return <div>
      <div className={css({
      ...theme.typography.LabelSmall,
      marginBottom: theme.sizing.scale300
    })}>
        {FRAME_CLASSIFICATION_PANEL_CONSTANTS.INSTANCE_LABEL}
      </div>
      <Select options={OPTIONS} value={OPTIONS.filter(option => option.id === value)} onChange={params => {
      const temporalScope = (params.value[0]?.id as TemporalScopeT | undefined);
      if (temporalScope) {
        onChange(temporalScope);
      }
    }} size={SIZE.compact} clearable={false} searchable={false} disabled={disabled} />
    </div>;
};